import React from 'react';
import HsSelect from '../../Form/HsSelect';
import { strings } from '../../../assets/strings/all';
const HsCountryFilter = (props) => {
  const { auth } = strings;
  const { onChange, type } = props;

  const Countries = [
    {
      name: 'All',
      slug: undefined,
    },
    {
      name: 'Lebanon',
      slug: 118,
    },
    {
      name: 'India',
      slug: 99,
    },
    {
      name: 'Algeria',
      slug: 2,
    },
    {
      name: 'Egypt',
      slug: 63,
    },
  ];

  return (
    <>
      <HsSelect
        label={auth.country}
        placeholder={auth.country}
        options={[{ label: auth.country, options: Countries }]}
        // defaultIcon="icon-ico-hide"
        defaultValue={Countries[0]}
        onChange={onChange}
        isClearable={false}
        {...props}
        // value={caseData.visibilityStatus}
      />
    </>
  );
};

export default HsCountryFilter;
